export const SMC_DOCTORS = [
  {
    i: "smc-0001",
    hid: "smc",
    n: "송윤미",
    de: "가정의학과",
    s: ["암치료후건강관리", "흔한급성질병및만성질병(고혈압"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0002",
    hid: "smc",
    n: "신동욱",
    de: "가정의학과",
    s: ["암치료후건강관리", "흔한급성질병및만성질병(고혈압"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0003",
    hid: "smc",
    n: "조인영",
    de: "가정의학과",
    s: ["암치료후건강관리", "흔한급성질병및만성질병(고혈압"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0004",
    hid: "smc",
    n: "김성혜",
    de: "가정의학과",
    s: ["암치료후건강관리", "흔한급성질병및만성질병(고혈압"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0005",
    hid: "smc",
    n: "장유진",
    de: "가정의학과",
    s: ["암치료후건강관리", "흔한급성질병및만성질병(고혈압"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0006",
    hid: "smc",
    n: "최혜림",
    de: "가정의학과",
    s: ["암치료후건강관리", "흔한급성질병및만성질병(고혈압"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0007",
    hid: "smc",
    n: "백경란",
    de: "감염내과",
    s: ["면역저하자감염", "불명열"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0008",
    hid: "smc",
    n: "정두련",
    de: "감염내과",
    s: ["폐렴", "불명열"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0009",
    hid: "smc",
    n: "강철인",
    de: "감염내과",
    s: ["불명열", "폐렴"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0010",
    hid: "smc",
    n: "조선영",
    de: "감염내과",
    s: ["요로감염", "폐렴"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0011",
    hid: "smc",
    n: "허경민",
    de: "감염내과",
    s: ["불명열", "면역저하자감염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0012",
    hid: "smc",
    n: "고재훈",
    de: "감염내과",
    s: ["면역저하자감염", "불명열"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0013",
    hid: "smc",
    n: "양진영",
    de: "감염내과",
    s: ["불명열", "면역저하자감염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0014",
    hid: "smc",
    n: "김선욱",
    de: "내분비대사내과",
    s: ["갑상선질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0015",
    hid: "smc",
    n: "김재현",
    de: "내분비대사내과",
    s: ["당뇨병", "1형당뇨병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0016",
    hid: "smc",
    n: "허규연",
    de: "내분비대사내과",
    s: ["당뇨병", "뇌하수체질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0017",
    hid: "smc",
    n: "진상만",
    de: "내분비대사내과",
    s: ["당뇨병", "부신질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0018",
    hid: "smc",
    n: "김태혁",
    de: "내분비대사내과",
    s: ["갑상선질환", "갑상선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0019",
    hid: "smc",
    n: "김규리",
    de: "내분비대사내과",
    s: ["당뇨병", "1형당뇨병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0020",
    hid: "smc",
    n: "이유빈",
    de: "내분비대사내과",
    s: ["뇌하수체질환", "부신질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0021",
    hid: "smc",
    n: "유지현",
    de: "내분비대사내과",
    s: ["당뇨병", "갑상선질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0022",
    hid: "smc",
    n: "조소현",
    de: "내분비대사내과",
    s: ["당뇨병", "갑상선질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0023",
    hid: "smc",
    n: "김지윤",
    de: "내분비대사내과",
    s: ["당뇨병", "1형당뇨병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0024",
    hid: "smc",
    n: "차훈석",
    de: "류마티스내과",
    s: ["강직성척추염", "전신홍반성루푸스"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0025",
    hid: "smc",
    n: "이재준",
    de: "류마티스내과",
    s: ["류마티스관절염", "강직성척추염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0026",
    hid: "smc",
    n: "이슬기",
    de: "류마티스내과",
    s: ["강직성척추염", "류마티스관절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0027",
    hid: "smc",
    n: "강선영",
    de: "류마티스내과",
    s: ["통풍", "류마티스관절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0028",
    hid: "smc",
    n: "이풍렬",
    de: "소화기내과",
    s: ["역류성식도염", "변비"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0029",
    hid: "smc",
    n: "이규택",
    de: "소화기내과",
    s: ["췌장암", "담낭암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0030",
    hid: "smc",
    n: "이준혁",
    de: "소화기내과",
    s: ["간암", "간경화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0031",
    hid: "smc",
    n: "이종균",
    de: "소화기내과",
    s: ["췌장암", "담낭암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0032",
    hid: "smc",
    n: "손희정",
    de: "소화기내과",
    s: ["위염", "위궤양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0033",
    hid: "smc",
    n: "김영호",
    de: "소화기내과",
    s: ["염증성장질환", "장결핵"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0034",
    hid: "smc",
    n: "장동경",
    de: "소화기내과",
    s: ["대장암", "대장용종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0035",
    hid: "smc",
    n: "최문석",
    de: "소화기내과",
    s: ["간암", "간경화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0036",
    hid: "smc",
    n: "이준행",
    de: "소화기내과",
    s: ["위암", "위식도역류질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0037",
    hid: "smc",
    n: "백용한",
    de: "소화기내과",
    s: ["간암", "간경화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0038",
    hid: "smc",
    n: "이광혁",
    de: "소화기내과",
    s: ["췌장암", "담낭암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0039",
    hid: "smc",
    n: "곽금연",
    de: "소화기내과",
    s: ["간암", "간경화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0040",
    hid: "smc",
    n: "민병훈",
    de: "소화기내과",
    s: ["위암", "치료내시경"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0041",
    hid: "smc",
    n: "홍성노",
    de: "소화기내과",
    s: ["염증성장질환", "궤양성대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0042",
    hid: "smc",
    n: "이혁",
    de: "소화기내과",
    s: ["위암", "위의양성종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0043",
    hid: "smc",
    n: "박주경",
    de: "소화기내과",
    s: ["췌장암", "담낭암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0044",
    hid: "smc",
    n: "신동현",
    de: "소화기내과",
    s: ["간암", "B형간염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0045",
    hid: "smc",
    n: "김은란",
    de: "소화기내과",
    s: ["대장암", "대장용종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0046",
    hid: "smc",
    n: "민양원",
    de: "소화기내과",
    s: ["기능성식도질환및식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0047",
    hid: "smc",
    n: "강원석",
    de: "소화기내과",
    s: ["바이러스성간염", "간경화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0048",
    hid: "smc",
    n: "최영훈",
    de: "소화기내과",
    s: ["췌장암", "담낭암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0049",
    hid: "smc",
    n: "장동기",
    de: "소화기내과",
    s: ["췌장암", "담낭암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0050",
    hid: "smc",
    n: "송병근",
    de: "소화기내과",
    s: ["간암", "간경화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0051",
    hid: "smc",
    n: "고명지",
    de: "소화기내과",
    s: ["간암", "간경화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0052",
    hid: "smc",
    n: "김태세",
    de: "소화기내과",
    s: ["위암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0053",
    hid: "smc",
    n: "김지은",
    de: "소화기내과",
    s: ["대장암", "대장용종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0054",
    hid: "smc",
    n: "김민지",
    de: "소화기내과",
    s: ["위암", "위선종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0055",
    hid: "smc",
    n: "오영은",
    de: "소화기내과",
    s: ["위용종", "위선종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0056",
    hid: "smc",
    n: "김경완",
    de: "소화기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0057",
    hid: "smc",
    n: "박승우",
    de: "순환기내과",
    s: ["심장판막증", "심근경색증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0058",
    hid: "smc",
    n: "권현철",
    de: "순환기내과",
    s: ["심장혈관중재시술", "협심증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0059",
    hid: "smc",
    n: "성지동",
    de: "순환기내과",
    s: ["고혈압", "고지혈증(고콜레스테롤혈증)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0060",
    hid: "smc",
    n: "온영근",
    de: "순환기내과",
    s: ["부정맥", "실신"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0061",
    hid: "smc",
    n: "이상철",
    de: "순환기내과",
    s: ["심근질환", "비후성심근증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0062",
    hid: "smc",
    n: "최진호",
    de: "순환기내과",
    s: ["심장혈관중재시술", "심근경색증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0063",
    hid: "smc",
    n: "최승혁",
    de: "순환기내과",
    s: ["협심증", "심근경색증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0064",
    hid: "smc",
    n: "한주용",
    de: "순환기내과",
    s: ["심장혈관중재시술", "협심증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0065",
    hid: "smc",
    n: "최진오",
    de: "순환기내과",
    s: ["심부전", "심근질환(심근병증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0066",
    hid: "smc",
    n: "박성지",
    de: "순환기내과",
    s: ["심장판막증", "판막시술(TAVI"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0067",
    hid: "smc",
    n: "박경민",
    de: "순환기내과",
    s: ["심실성빈맥", "심장돌연사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0068",
    hid: "smc",
    n: "송영빈",
    de: "순환기내과",
    s: ["심장혈관중재시술", "협심증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0069",
    hid: "smc",
    n: "박승정",
    de: "순환기내과",
    s: ["인공심장박동기", "박동기/제세동기 전극선제거"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0070",
    hid: "smc",
    n: "장성아",
    de: "순환기내과",
    s: ["폐동맥고혈압", "폐동맥색전증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0071",
    hid: "smc",
    n: "양정훈",
    de: "순환기내과",
    s: ["심인성쇼크", "체외막형산소화요법"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0072",
    hid: "smc",
    n: "박택규",
    de: "순환기내과",
    s: ["말판증후군", "타카야수동맥염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0073",
    hid: "smc",
    n: "이주명",
    de: "순환기내과",
    s: ["협심증", "심근경색증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0074",
    hid: "smc",
    n: "김은경",
    de: "순환기내과",
    s: ["심장판막질환", "암관련 심장질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0075",
    hid: "smc",
    n: "김다래",
    de: "순환기내과",
    s: ["심부전", "심근질환(심근병증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0076",
    hid: "smc",
    n: "최기홍",
    de: "순환기내과",
    s: ["협심증", "죽상경화성심혈관병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0077",
    hid: "smc",
    n: "김지훈",
    de: "순환기내과",
    s: ["심장판막증", "심장초음파검사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0078",
    hid: "smc",
    n: "김주연",
    de: "순환기내과",
    s: ["부정맥", "심방세동"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0079",
    hid: "smc",
    n: "김주원",
    de: "순환기내과",
    s: ["부정맥", "실신"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0080",
    hid: "smc",
    n: "이상윤",
    de: "순환기내과",
    s: ["심장혈관중재시술", "말판증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0081",
    hid: "smc",
    n: "홍다위",
    de: "순환기내과",
    s: ["심부전", "심장이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0082",
    hid: "smc",
    n: "허우성",
    de: "신장내과",
    s: ["신장이식(콩팥이식)", "만성신질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0083",
    hid: "smc",
    n: "이정은",
    de: "신장내과",
    s: ["IgA신증", "신증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0084",
    hid: "smc",
    n: "장혜련",
    de: "신장내과",
    s: ["신장이식(콩팥이식)", "사구체신질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0085",
    hid: "smc",
    n: "전준석",
    de: "신장내과",
    s: ["만성신질환", "급성신손상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0086",
    hid: "smc",
    n: "이경호",
    de: "신장내과",
    s: ["급성신손상(중증)", "만성신질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0087",
    hid: "smc",
    n: "이병재",
    de: "알레르기내과",
    s: ["만성기침", "천식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0088",
    hid: "smc",
    n: "강노을",
    de: "알레르기내과",
    s: ["천식", "중증 천식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0089",
    hid: "smc",
    n: "박영석",
    de: "혈액종양내과",
    s: ["대장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0090",
    hid: "smc",
    n: "정철원",
    de: "혈액종양내과",
    s: ["백혈병", "조혈모세포이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0091",
    hid: "smc",
    n: "안진석",
    de: "혈액종양내과",
    s: ["폐암", "유방암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0092",
    hid: "smc",
    n: "김원석",
    de: "혈액종양내과",
    s: ["림프종", "CAR-T세포치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0093",
    hid: "smc",
    n: "김기현",
    de: "혈액종양내과",
    s: ["다발성골수종", "아밀로이드증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0094",
    hid: "smc",
    n: "박준오",
    de: "혈액종양내과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0095",
    hid: "smc",
    n: "장준호",
    de: "혈액종양내과",
    s: ["골수형성이상증후군", "재생불량성빈혈"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0096",
    hid: "smc",
    n: "박연희",
    de: "혈액종양내과",
    s: ["유방암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0097",
    hid: "smc",
    n: "김석진",
    de: "혈액종양내과",
    s: ["림프종", "조혈모세포이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0098",
    hid: "smc",
    n: "박세훈",
    de: "혈액종양내과",
    s: ["비뇨의학암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0099",
    hid: "smc",
    n: "이세훈",
    de: "혈액종양내과",
    s: ["폐암", "두경부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0100",
    hid: "smc",
    n: "이지연",
    de: "혈액종양내과",
    s: ["위암", "암정밀치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0101",
    hid: "smc",
    n: "선종무",
    de: "혈액종양내과",
    s: ["폐암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0102",
    hid: "smc",
    n: "김승태",
    de: "혈액종양내과",
    s: ["위암", "대장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0103",
    hid: "smc",
    n: "홍정용",
    de: "혈액종양내과",
    s: ["간암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0104",
    hid: "smc",
    n: "안희경",
    de: "혈액종양내과",
    s: ["유방암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0105",
    hid: "smc",
    n: "정현애",
    de: "혈액종양내과",
    s: ["폐암", "두경부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0106",
    hid: "smc",
    n: "임성희",
    de: "혈액종양내과",
    s: ["대장암", "위암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0107",
    hid: "smc",
    n: "김지연",
    de: "혈액종양내과",
    s: ["유방암", "원발부위불명암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0108",
    hid: "smc",
    n: "윤상은",
    de: "혈액종양내과",
    s: ["악성림프종", "CAR-T세포치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0109",
    hid: "smc",
    n: "이준호",
    de: "혈액종양내과",
    s: ["다발성골수종", "아밀로이드증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0110",
    hid: "smc",
    n: "권민석",
    de: "혈액종양내과",
    s: ["위암", "비뇨의학암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0111",
    hid: "smc",
    n: "신정훈",
    de: "혈액종양내과",
    s: ["유방암", "원발부위불명암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0112",
    hid: "smc",
    n: "최대호",
    de: "혈액종양내과",
    s: ["백혈병", "만성골수증식성질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0113",
    hid: "smc",
    n: "김진영",
    de: "혈액종양내과",
    s: ["폐암", "두경부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0114",
    hid: "smc",
    n: "신지은",
    de: "혈액종양내과",
    s: ["대장암", "췌장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0115",
    hid: "smc",
    n: "김준규",
    de: "혈액종양내과",
    s: ["폐암", "두경부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0116",
    hid: "smc",
    n: "장서윤",
    de: "혈액종양내과",
    s: ["위암", "대장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0117",
    hid: "smc",
    n: "정만표",
    de: "호흡기내과",
    s: ["간질성폐질환", "폐섬유화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0118",
    hid: "smc",
    n: "서지영",
    de: "호흡기내과",
    s: ["중환자관리", "급성호흡부전"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0119",
    hid: "smc",
    n: "정병호",
    de: "호흡기내과",
    s: ["폐암", "기관지내시경"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0120",
    hid: "smc",
    n: "전병우",
    de: "호흡기내과",
    s: ["비결핵항산균폐질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0121",
    hid: "smc",
    n: "엄상원",
    de: "호흡기내과",
    s: ["폐암", "폐결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0122",
    hid: "smc",
    n: "전경만",
    de: "호흡기내과",
    s: ["중환자의학", "폐이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0123",
    hid: "smc",
    n: "이경종",
    de: "호흡기내과",
    s: ["폐암", "폐결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0124",
    hid: "smc",
    n: "박혜윤",
    de: "호흡기내과",
    s: ["만성폐쇄성폐질환", "만성기도질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0125",
    hid: "smc",
    n: "유홍석",
    de: "호흡기내과",
    s: ["간질성폐질환", "폐섬유화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0126",
    hid: "smc",
    n: "신선혜",
    de: "호흡기내과",
    s: ["만성폐쇄성폐질환", "폐암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0127",
    hid: "smc",
    n: "최준수",
    de: "호흡기내과",
    s: ["로봇기관지내시경", "폐이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0128",
    hid: "smc",
    n: "김소연",
    de: "호흡기내과",
    s: ["폐암", "폐결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0129",
    hid: "smc",
    n: "조현성",
    de: "마취통증의학과",
    s: ["심장마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0130",
    hid: "smc",
    n: "이상민",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0131",
    hid: "smc",
    n: "김갑수",
    de: "마취통증의학과",
    s: ["이식마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0132",
    hid: "smc",
    n: "김정수",
    de: "마취통증의학과",
    s: ["심장마취", "부인과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0133",
    hid: "smc",
    n: "함태수",
    de: "마취통증의학과",
    s: ["부인과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0134",
    hid: "smc",
    n: "양미경",
    de: "마취통증의학과",
    s: ["폐식도마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0135",
    hid: "smc",
    n: "이정진",
    de: "마취통증의학과",
    s: ["뇌신경마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0136",
    hid: "smc",
    n: "심우석",
    de: "마취통증의학과",
    s: ["급성통증관리", "만성통증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0137",
    hid: "smc",
    n: "곽미숙",
    de: "마취통증의학과",
    s: ["이식마취", "정형외과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0138",
    hid: "smc",
    n: "김지애",
    de: "마취통증의학과",
    s: ["폐식도마취", "외과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0139",
    hid: "smc",
    n: "최수주",
    de: "마취통증의학과",
    s: ["정형외과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0140",
    hid: "smc",
    n: "김진경",
    de: "마취통증의학과",
    s: ["이비인후과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0141",
    hid: "smc",
    n: "신병섭",
    de: "마취통증의학과",
    s: ["비뇨의학과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0142",
    hid: "smc",
    n: "김덕경",
    de: "마취통증의학과",
    s: ["외과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0143",
    hid: "smc",
    n: "안현주",
    de: "마취통증의학과",
    s: ["폐식도마취", "외과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0144",
    hid: "smc",
    n: "이진영",
    de: "마취통증의학과",
    s: ["부위마취", "급성/만성통증관리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0145",
    hid: "smc",
    n: "이종환",
    de: "마취통증의학과",
    s: ["심혈관마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0146",
    hid: "smc",
    n: "길남수",
    de: "마취통증의학과",
    s: ["수술실외부마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0147",
    hid: "smc",
    n: "신영희",
    de: "마취통증의학과",
    s: ["소아마취", "성형외과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0148",
    hid: "smc",
    n: "이상현",
    de: "마취통증의학과",
    s: ["이비인후과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0149",
    hid: "smc",
    n: "정지선",
    de: "마취통증의학과",
    s: ["부위마취", "뇌신경마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0150",
    hid: "smc",
    n: "한상빈",
    de: "마취통증의학과",
    s: ["간이식마취", "국소부위마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0151",
    hid: "smc",
    n: "이숙영",
    de: "마취통증의학과",
    s: ["통원수술마취", "외과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0152",
    hid: "smc",
    n: "최지원",
    de: "마취통증의학과",
    s: ["급성/만성통증관리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0153",
    hid: "smc",
    n: "정인선",
    de: "마취통증의학과",
    s: ["수술실외부마취", "다빈치로봇수술마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0154",
    hid: "smc",
    n: "윤진선",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0155",
    hid: "smc",
    n: "민정진",
    de: "마취통증의학과",
    s: ["심혈관마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0156",
    hid: "smc",
    n: "김영리",
    de: "마취통증의학과",
    s: ["통원수술마취", "수술실외부마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0157",
    hid: "smc",
    n: "박미혜",
    de: "마취통증의학과",
    s: ["외과마취", "암환자마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0158",
    hid: "smc",
    n: "박정찬",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0159",
    hid: "smc",
    n: "임현영",
    de: "마취통증의학과",
    s: ["외과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0160",
    hid: "smc",
    n: "강령아",
    de: "마취통증의학과",
    s: ["부위마취", "정형외과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0161",
    hid: "smc",
    n: "권지혜",
    de: "마취통증의학과",
    s: ["이식마취", "뇌신경마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0162",
    hid: "smc",
    n: "김수연",
    de: "마취통증의학과",
    s: ["통원수술마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0163",
    hid: "smc",
    n: "정희준",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0164",
    hid: "smc",
    n: "이승원",
    de: "마취통증의학과",
    s: ["소아마취", "수술실외부마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0165",
    hid: "smc",
    n: "김제연",
    de: "마취통증의학과",
    s: ["폐식도마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0166",
    hid: "smc",
    n: "오아란",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0167",
    hid: "smc",
    n: "방유정",
    de: "마취통증의학과",
    s: ["부위마취", "산부인과마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0168",
    hid: "smc",
    n: "노연지",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0169",
    hid: "smc",
    n: "윤시정",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0170",
    hid: "smc",
    n: "선정은",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0171",
    hid: "smc",
    n: "김소진",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0172",
    hid: "smc",
    n: "기유민",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0173",
    hid: "smc",
    n: "김유정",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0174",
    hid: "smc",
    n: "신혜경",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0175",
    hid: "smc",
    n: "주소민",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0176",
    hid: "smc",
    n: "장윤실",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0177",
    hid: "smc",
    n: "조민경",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0178",
    hid: "smc",
    n: "최지선",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0179",
    hid: "smc",
    n: "표홍렬",
    de: "방사선종양학과",
    s: ["폐암(육종포함)", "전립선/비뇨기암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0180",
    hid: "smc",
    n: "임도훈",
    de: "방사선종양학과",
    s: ["뇌종양", "소아암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0181",
    hid: "smc",
    n: "박희철",
    de: "방사선종양학과",
    s: ["간암", "췌장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0182",
    hid: "smc",
    n: "박원",
    de: "방사선종양학과",
    s: ["비뇨기암", "부인암(육종포함)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0183",
    hid: "smc",
    n: "노재명",
    de: "방사선종양학과",
    s: ["폐암", "갑상선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0184",
    hid: "smc",
    n: "김해영",
    de: "방사선종양학과",
    s: ["유방암", "림프종(위"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0185",
    hid: "smc",
    n: "오동렬",
    de: "방사선종양학과",
    s: ["두경부암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0186",
    hid: "smc",
    n: "유정일",
    de: "방사선종양학과",
    s: ["대장/직장/항문암", "간암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0187",
    hid: "smc",
    n: "조원경",
    de: "방사선종양학과",
    s: ["부인암(육종포함)", "유방암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0188",
    hid: "smc",
    n: "김나리",
    de: "방사선종양학과",
    s: ["대장/직장/항문암", "뇌종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0189",
    hid: "smc",
    n: "양경미",
    de: "방사선종양학과",
    s: ["두경부암", "폐암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0190",
    hid: "smc",
    n: "이태훈",
    de: "방사선종양학과",
    s: ["유방암", "비뇨기암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0191",
    hid: "smc",
    n: "백종윤",
    de: "방사선종양학과",
    s: ["두경부암", "유방암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0192",
    hid: "smc",
    n: "오영륜",
    de: "병리과",
    s: ["내분비병리", "세포병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0193",
    hid: "smc",
    n: "권기영",
    de: "병리과",
    s: ["비뇨병리의학", "신장병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0194",
    hid: "smc",
    n: "김석형",
    de: "병리과",
    s: ["소화기병리", "대장암병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0195",
    hid: "smc",
    n: "한정호",
    de: "병리과",
    s: ["폐병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0196",
    hid: "smc",
    n: "장기택",
    de: "병리과",
    s: ["피부병리", "췌담관계병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0197",
    hid: "smc",
    n: "김경미",
    de: "병리과",
    s: ["소화기병리", "분자병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0198",
    hid: "smc",
    n: "김정선",
    de: "병리과",
    s: ["분자병리", "소아병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0199",
    hid: "smc",
    n: "최윤라",
    de: "병리과",
    s: ["폐병리", "골연부조직병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0200",
    hid: "smc",
    n: "조은윤",
    de: "병리과",
    s: ["유방병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0201",
    hid: "smc",
    n: "이윤경",
    de: "병리과",
    s: ["세포병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0202",
    hid: "smc",
    n: "하상윤",
    de: "병리과",
    s: ["소화기병리", "간병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0203",
    hid: "smc",
    n: "김현수",
    de: "병리과",
    s: ["산부인과병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0204",
    hid: "smc",
    n: "안수민",
    de: "병리과",
    s: ["소화기병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0205",
    hid: "smc",
    n: "이현우",
    de: "병리과",
    s: ["유방병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0206",
    hid: "smc",
    n: "안혜선",
    de: "병리과",
    s: ["소화기병리", "비뇨병리의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0207",
    hid: "smc",
    n: "이보람",
    de: "병리과",
    s: ["신경병리", "폐병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0208",
    hid: "smc",
    n: "한나영",
    de: "병리과",
    s: ["혈액병리", "두경부병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0209",
    hid: "smc",
    n: "김세희",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0210",
    hid: "smc",
    n: "조윤아",
    de: "병리과",
    s: ["유방병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0211",
    hid: "smc",
    n: "고영혜",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0212",
    hid: "smc",
    n: "김현희",
    de: "병리과",
    s: ["신경병리", "유방병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0213",
    hid: "smc",
    n: "한보경",
    de: "병리과",
    s: ["내분비병리", "유방병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0214",
    hid: "smc",
    n: "황인우",
    de: "병리과",
    s: ["비뇨병리의학", "소화기병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0215",
    hid: "smc",
    n: "이유리미",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0216",
    hid: "smc",
    n: "조윤주",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0217",
    hid: "smc",
    n: "이규성",
    de: "비뇨의학과",
    s: ["전립선비대증", "과민성방광"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0218",
    hid: "smc",
    n: "한덕현",
    de: "비뇨의학과",
    s: ["요로결석(요석증)", "요관협착"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0219",
    hid: "smc",
    n: "전황균",
    de: "비뇨의학과",
    s: ["전립선암", "로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0220",
    hid: "smc",
    n: "서성일",
    de: "비뇨의학과",
    s: ["신장암", "전립선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0221",
    hid: "smc",
    n: "성현환",
    de: "비뇨의학과",
    s: ["방광암", "신우암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0222",
    hid: "smc",
    n: "강민용",
    de: "비뇨의학과",
    s: ["신장암", "전립선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0223",
    hid: "smc",
    n: "전성수",
    de: "비뇨의학과",
    s: ["전립선암", "로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0224",
    hid: "smc",
    n: "정병창",
    de: "비뇨의학과",
    s: ["방광암", "전립선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0225",
    hid: "smc",
    n: "이혜원",
    de: "비뇨의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0226",
    hid: "smc",
    n: "송완",
    de: "비뇨의학과",
    s: ["전립선암", "로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0227",
    hid: "smc",
    n: "고광진",
    de: "비뇨의학과",
    s: ["전립선비대증", "과민성방광"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0228",
    hid: "smc",
    n: "이종훈",
    de: "비뇨의학과",
    s: ["수신증", "방광요관역류"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0229",
    hid: "smc",
    n: "유지웅",
    de: "비뇨의학과",
    s: ["전립선암", "신장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0230",
    hid: "smc",
    n: "강진석",
    de: "비뇨의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0231",
    hid: "smc",
    n: "최두석",
    de: "산부인과",
    s: ["자궁내막증", "난임"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0232",
    hid: "smc",
    n: "이정원",
    de: "산부인과",
    s: ["자궁경부암", "난소암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0233",
    hid: "smc",
    n: "오수영",
    de: "산부인과",
    s: ["고위험임신", "조산"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0234",
    hid: "smc",
    n: "최석주",
    de: "산부인과",
    s: ["고위험임신", "정밀초음파검사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0235",
    hid: "smc",
    n: "김태중",
    de: "산부인과",
    s: ["자궁내막암", "난소암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0236",
    hid: "smc",
    n: "최철훈",
    de: "산부인과",
    s: ["난소암", "자궁경부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0237",
    hid: "smc",
    n: "이동윤",
    de: "산부인과",
    s: ["자궁근종", "난소종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0238",
    hid: "smc",
    n: "이유영",
    de: "산부인과",
    s: ["난소암", "복막암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0239",
    hid: "smc",
    n: "강윤단",
    de: "산부인과",
    s: ["고위험임신", "자궁경부무력증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0240",
    hid: "smc",
    n: "성지희",
    de: "산부인과",
    s: ["고위험임신", "정밀초음파검사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0241",
    hid: "smc",
    n: "김성은",
    de: "산부인과",
    s: ["난임", "시험관아기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0242",
    hid: "smc",
    n: "서준형",
    de: "산부인과",
    s: ["난소암", "난관암(나팔관암)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0243",
    hid: "smc",
    n: "임승연",
    de: "산부인과",
    s: ["일반부인과질환", "양성 부인종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0244",
    hid: "smc",
    n: "정영은",
    de: "산부인과",
    s: ["일반부인과질환", "양성 부인종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0245",
    hid: "smc",
    n: "함수지",
    de: "산부인과",
    s: ["고위험임신", "태아기형산전진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0246",
    hid: "smc",
    n: "문구현",
    de: "성형외과",
    s: ["유방재건"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0247",
    hid: "smc",
    n: "변재경",
    de: "성형외과",
    s: ["유방재건"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0248",
    hid: "smc",
    n: "임소영",
    de: "성형외과",
    s: ["두개골조기유합증", "구개구순열"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0249",
    hid: "smc",
    n: "전병준",
    de: "성형외과",
    s: ["유방재건", "림프부종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0250",
    hid: "smc",
    n: "우경제",
    de: "성형외과",
    s: ["유방재건", "림프부종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0251",
    hid: "smc",
    n: "이경태",
    de: "성형외과",
    s: ["흑색종", "피부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0252",
    hid: "smc",
    n: "배주영",
    de: "성형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0253",
    hid: "smc",
    n: "김지수",
    de: "성형외과",
    s: ["피부암", "미세수술재건"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0254",
    hid: "smc",
    n: "김진아",
    de: "성형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0255",
    hid: "smc",
    n: "강이석",
    de: "소아청소년과",
    s: ["선천성심장병", "심도자치료술(비수술적치료)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0256",
    hid: "smc",
    n: "성기웅",
    de: "소아청소년과",
    s: ["신경모세포종", "뇌종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0257",
    hid: "smc",
    n: "장윤실",
    de: "소아청소년과",
    s: ["고위험신생아", "미숙아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0258",
    hid: "smc",
    n: "이지훈",
    de: "소아청소년과",
    s: ["신경유전", "소아뇌전증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0259",
    hid: "smc",
    n: "최연호",
    de: "소아청소년과",
    s: ["크론병", "궤양성대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0260",
    hid: "smc",
    n: "안강모",
    de: "소아청소년과",
    s: ["아토피피부염", "식품알레르기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0261",
    hid: "smc",
    n: "허준",
    de: "소아청소년과",
    s: ["소아청소년및성인선천성심장병", "선천성심장병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0262",
    hid: "smc",
    n: "송진영",
    de: "소아청소년과",
    s: ["비수술적결손폐쇄", "심도자치료술(비수술적치료)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0263",
    hid: "smc",
    n: "김예진",
    de: "소아청소년과",
    s: ["감염질환", "선천(일차)면역결핍증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0264",
    hid: "smc",
    n: "유건희",
    de: "소아청소년과",
    s: ["빈혈", "소아암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0265",
    hid: "smc",
    n: "김지현",
    de: "소아청소년과",
    s: ["아토피피부염", "식품알레르기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0266",
    hid: "smc",
    n: "윤자경",
    de: "소아청소년과",
    s: ["소아부정맥", "선천성심장병부정맥"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0267",
    hid: "smc",
    n: "조희연",
    de: "소아청소년과",
    s: ["급성신손상및만성신장질환", "소변이상을동반한사구체및세뇨관질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0268",
    hid: "smc",
    n: "성세인",
    de: "소아청소년과",
    s: ["미숙아", "저체중아및고위험신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0269",
    hid: "smc",
    n: "이지원",
    de: "소아청소년과",
    s: ["소아뇌전증(유전성뇌전증", "난치성뇌전증)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0270",
    hid: "smc",
    n: "김미진",
    de: "소아청소년과",
    s: ["크론병", "궤양성대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0271",
    hid: "smc",
    n: "조성윤",
    de: "소아청소년과",
    s: ["저신장", "성조숙"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0272",
    hid: "smc",
    n: "안소윤",
    de: "소아청소년과",
    s: ["미숙아", "고위험신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0273",
    hid: "smc",
    n: "주희영",
    de: "소아청소년과",
    s: ["백혈병", "림프종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0274",
    hid: "smc",
    n: "김수경",
    de: "소아청소년과",
    s: ["아토피피부염", "식품알레르기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0275",
    hid: "smc",
    n: "양미선",
    de: "소아청소년과",
    s: ["신생아", "미숙아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0276",
    hid: "smc",
    n: "김정연",
    de: "소아청소년과",
    s: ["혈뇨", "단백뇨"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0277",
    hid: "smc",
    n: "김혜선",
    de: "소아청소년과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0278",
    hid: "smc",
    n: "정민영",
    de: "소아청소년과",
    s: ["아토피피부염", "식품알레르기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0279",
    hid: "smc",
    n: "이나현",
    de: "소아청소년과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0280",
    hid: "smc",
    n: "조희원",
    de: "소아청소년과",
    s: ["소아뇌종양", "소아암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0281",
    hid: "smc",
    n: "임민지",
    de: "소아청소년과",
    s: ["저신장", "성조숙"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0282",
    hid: "smc",
    n: "최광준",
    de: "소아청소년과",
    s: ["선천성심장병", "심도자치료술(비수술적치료)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0283",
    hid: "smc",
    n: "권이영",
    de: "소아청소년과",
    s: ["크론병", "궤양성대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0284",
    hid: "smc",
    n: "곽신형",
    de: "소아청소년과",
    s: ["선천성심장병", "심도자치료술(비수술적치료)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0285",
    hid: "smc",
    n: "성주영",
    de: "소아청소년과",
    s: ["내분비질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0286",
    hid: "smc",
    n: "김두리",
    de: "소아청소년과",
    s: ["감염질환", "선천(일차)면역결핍증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0287",
    hid: "smc",
    n: "김윤지",
    de: "소아청소년과",
    s: ["크론병", "궤양성대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0288",
    hid: "smc",
    n: "신아름",
    de: "소아청소년과",
    s: ["감염질환", "선천(일차)면역결핍증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0289",
    hid: "smc",
    n: "노현승",
    de: "소아청소년과",
    s: ["소아질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0290",
    hid: "smc",
    n: "최새롬",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0291",
    hid: "smc",
    n: "윤희정",
    de: "소아청소년과",
    s: ["소아질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0292",
    hid: "smc",
    n: "현주경",
    de: "소아청소년과",
    s: ["소아암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0293",
    hid: "smc",
    n: "천정미",
    de: "소아청소년과",
    s: ["소아외과질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0294",
    hid: "smc",
    n: "김선녀",
    de: "소아청소년과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0295",
    hid: "smc",
    n: "김찬",
    de: "소아청소년과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0296",
    hid: "smc",
    n: "박성현",
    de: "소아청소년과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0297",
    hid: "smc",
    n: "김소진",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0298",
    hid: "smc",
    n: "이의수",
    de: "소아청소년과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0299",
    hid: "smc",
    n: "김예진",
    de: "소아감염면역",
    s: ["감염질환", "선천(일차)면역결핍증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0300",
    hid: "smc",
    n: "김두리",
    de: "소아감염면역",
    s: ["감염질환", "선천(일차)면역결핍증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0301",
    hid: "smc",
    n: "신아름",
    de: "소아감염면역",
    s: ["감염질환", "선천(일차)면역결핍증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0302",
    hid: "smc",
    n: "조성윤",
    de: "소아내분비유전대사",
    s: ["저신장", "성조숙"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0303",
    hid: "smc",
    n: "임민지",
    de: "소아내분비유전대사",
    s: ["저신장", "성조숙"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0304",
    hid: "smc",
    n: "성주영",
    de: "소아내분비유전대사",
    s: ["내분비질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0305",
    hid: "smc",
    n: "최연호",
    de: "소아소화기영양",
    s: ["크론병", "궤양성대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0306",
    hid: "smc",
    n: "김미진",
    de: "소아소화기영양",
    s: ["크론병", "궤양성대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0307",
    hid: "smc",
    n: "권이영",
    de: "소아소화기영양",
    s: ["크론병", "궤양성대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0308",
    hid: "smc",
    n: "김윤지",
    de: "소아소화기영양",
    s: ["크론병", "궤양성대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0309",
    hid: "smc",
    n: "이지훈",
    de: "소아신경",
    s: ["신경유전", "소아뇌전증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0310",
    hid: "smc",
    n: "이지원",
    de: "소아신경",
    s: ["소아뇌전증(유전성뇌전증", "난치성뇌전증)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0311",
    hid: "smc",
    n: "장윤실",
    de: "신생아분과",
    s: ["고위험신생아", "미숙아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0312",
    hid: "smc",
    n: "성세인",
    de: "신생아분과",
    s: ["미숙아", "저체중아및고위험신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0313",
    hid: "smc",
    n: "안소윤",
    de: "신생아분과",
    s: ["미숙아", "고위험신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0314",
    hid: "smc",
    n: "양미선",
    de: "신생아분과",
    s: ["신생아", "미숙아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0315",
    hid: "smc",
    n: "김혜선",
    de: "신생아분과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0316",
    hid: "smc",
    n: "이나현",
    de: "신생아분과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0317",
    hid: "smc",
    n: "김선녀",
    de: "신생아분과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0318",
    hid: "smc",
    n: "김찬",
    de: "신생아분과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0319",
    hid: "smc",
    n: "박성현",
    de: "신생아분과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0320",
    hid: "smc",
    n: "김소진",
    de: "신생아분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0321",
    hid: "smc",
    n: "이의수",
    de: "신생아분과",
    s: ["신생아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0322",
    hid: "smc",
    n: "조희연",
    de: "소아신장",
    s: ["급성신손상및만성신장질환", "소변이상을동반한사구체및세뇨관질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0323",
    hid: "smc",
    n: "김정연",
    de: "소아신장",
    s: ["혈뇨", "단백뇨"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0324",
    hid: "smc",
    n: "강이석",
    de: "소아심장",
    s: ["선천성심장병", "심도자치료술(비수술적치료)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0325",
    hid: "smc",
    n: "허준",
    de: "소아심장",
    s: ["소아청소년및성인선천성심장병", "선천성심장병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0326",
    hid: "smc",
    n: "송진영",
    de: "소아심장",
    s: ["비수술적결손폐쇄", "심도자치료술(비수술적치료)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0327",
    hid: "smc",
    n: "윤자경",
    de: "소아심장",
    s: ["소아부정맥", "선천성심장병부정맥"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0328",
    hid: "smc",
    n: "최광준",
    de: "소아심장",
    s: ["선천성심장병", "심도자치료술(비수술적치료)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0329",
    hid: "smc",
    n: "곽신형",
    de: "소아심장",
    s: ["선천성심장병", "심도자치료술(비수술적치료)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0330",
    hid: "smc",
    n: "안강모",
    de: "소아알레르기호흡기",
    s: ["아토피피부염", "식품알레르기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0331",
    hid: "smc",
    n: "김지현",
    de: "소아알레르기호흡기",
    s: ["아토피피부염", "식품알레르기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0332",
    hid: "smc",
    n: "김수경",
    de: "소아알레르기호흡기",
    s: ["아토피피부염", "식품알레르기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0333",
    hid: "smc",
    n: "정민영",
    de: "소아알레르기호흡기",
    s: ["아토피피부염", "식품알레르기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0334",
    hid: "smc",
    n: "성기웅",
    de: "소아혈액종양",
    s: ["신경모세포종", "뇌종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0335",
    hid: "smc",
    n: "유건희",
    de: "소아혈액종양",
    s: ["빈혈", "소아암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0336",
    hid: "smc",
    n: "이지원",
    de: "소아혈액종양",
    s: ["소아고형암", "유전성암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0337",
    hid: "smc",
    n: "주희영",
    de: "소아혈액종양",
    s: ["백혈병", "림프종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0338",
    hid: "smc",
    n: "조희원",
    de: "소아혈액종양",
    s: ["소아뇌종양", "소아암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0339",
    hid: "smc",
    n: "김경문",
    de: "신경과",
    s: ["뇌졸중", "일과성뇌허혈"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0340",
    hid: "smc",
    n: "김병준",
    de: "신경과",
    s: ["다발성경화증", "시신경척수염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0341",
    hid: "smc",
    n: "서대원",
    de: "신경과",
    s: ["뇌전증(경련", "발작"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0342",
    hid: "smc",
    n: "최병옥",
    de: "신경과",
    s: ["말초신경병", "신경통증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0343",
    hid: "smc",
    n: "방오영",
    de: "신경과",
    s: ["뇌경색", "뇌졸중"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0344",
    hid: "smc",
    n: "조진환",
    de: "신경과",
    s: ["파킨슨병", "파킨슨증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0345",
    hid: "smc",
    n: "손영민",
    de: "신경과",
    s: ["뇌전증", "뇌전증신경조절술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0346",
    hid: "smc",
    n: "주은연",
    de: "신경과",
    s: ["불면증", "수면호흡장애(코골이"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0347",
    hid: "smc",
    n: "서상원",
    de: "신경과",
    s: ["경도인지장애", "알쯔하이머병(Alzheimer병)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0348",
    hid: "smc",
    n: "서우근",
    de: "신경과",
    s: ["뇌경색", "뇌졸중"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0349",
    hid: "smc",
    n: "민주홍",
    de: "신경과",
    s: ["다발성경화증", "시신경척수염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0350",
    hid: "smc",
    n: "윤진영",
    de: "신경과",
    s: ["뇌심부자극술", "파킨슨병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0351",
    hid: "smc",
    n: "김희진",
    de: "신경과",
    s: ["치매", "경도인지장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0352",
    hid: "smc",
    n: "정종원",
    de: "신경과",
    s: ["뇌경색", "뇌졸중"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0353",
    hid: "smc",
    n: "김준표",
    de: "신경과",
    s: ["치매", "기억장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0354",
    hid: "smc",
    n: "박혜리",
    de: "신경과",
    s: ["뇌전증", "뇌전증수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0355",
    hid: "smc",
    n: "김형준",
    de: "신경과",
    s: ["뇌졸중", "일과성뇌허혈"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0356",
    hid: "smc",
    n: "김종수",
    de: "신경외과",
    s: ["뇌동맥류", "모야모야병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0357",
    hid: "smc",
    n: "이정일",
    de: "신경외과",
    s: ["뇌종양", "감마나이프(뇌종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0358",
    hid: "smc",
    n: "남도현",
    de: "신경외과",
    s: ["뇌하수체종양", "뇌교종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0359",
    hid: "smc",
    n: "설호준",
    de: "신경외과",
    s: ["뇌기저부수술", "뇌종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0360",
    hid: "smc",
    n: "공두식",
    de: "신경외과",
    s: ["뇌수막종", "뇌교종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0361",
    hid: "smc",
    n: "이선호",
    de: "신경외과",
    s: ["척추/척수종양", "척추외상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0362",
    hid: "smc",
    n: "연제영",
    de: "신경외과",
    s: ["뇌동맥류", "뇌혈관기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0363",
    hid: "smc",
    n: "최정원",
    de: "신경외과",
    s: ["악성뇌종양", "뇌교종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0364",
    hid: "smc",
    n: "이승준",
    de: "신경외과",
    s: ["척추/척수종양", "경추"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0365",
    hid: "smc",
    n: "이승훈",
    de: "신경외과",
    s: ["삼차신경통", "안면경련"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0366",
    hid: "smc",
    n: "정규하",
    de: "신경외과",
    s: ["악성뇌종양", "전이성뇌종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0367",
    hid: "smc",
    n: "지태근",
    de: "신경외과",
    s: ["뇌동맥류", "모야모야병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0368",
    hid: "smc",
    n: "이원재",
    de: "신경외과",
    s: ["두개저종양", "뇌하수체종양의내시경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0369",
    hid: "smc",
    n: "배진우",
    de: "신경외과",
    s: ["뇌동맥류", "모야모야병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0370",
    hid: "smc",
    n: "하창민",
    de: "신경외과",
    s: ["경추", "요추"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0371",
    hid: "smc",
    n: "이종석",
    de: "신경외과",
    s: ["소아뇌종양", "소아모야모야병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0372",
    hid: "smc",
    n: "장경원",
    de: "신경외과",
    s: ["감마나이프", "초음파수술(파킨슨병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0373",
    hid: "smc",
    n: "최혜원",
    de: "신경외과",
    s: ["뇌동맥류", "모야모야병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0374",
    hid: "smc",
    n: "김은영",
    de: "신경외과",
    s: ["중환자의학", "신경중환자치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0375",
    hid: "smc",
    n: "전태국",
    de: "심장혈관흉부외과",
    s: ["선천성심장질환", "소아심장질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0376",
    hid: "smc",
    n: "김욱성",
    de: "심장혈관흉부외과",
    s: ["관상동맥수술", "판막수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0377",
    hid: "smc",
    n: "성기익",
    de: "심장혈관흉부외과",
    s: ["대동맥수술", "판막수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0378",
    hid: "smc",
    n: "양지혁",
    de: "심장혈관흉부외과",
    s: ["선천성심장질환", "소아심장수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0379",
    hid: "smc",
    n: "정동섭",
    de: "심장혈관흉부외과",
    s: ["판막", "관상동맥"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0380",
    hid: "smc",
    n: "조양현",
    de: "심장혈관흉부외과",
    s: ["인공심장및에크모", "심장보조장치"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0381",
    hid: "smc",
    n: "정수련",
    de: "심장혈관흉부외과",
    s: ["최소침습심장수술", "대동맥수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0382",
    hid: "smc",
    n: "박일근",
    de: "심장혈관흉부외과",
    s: ["선천성심장질환", "소아심장질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0383",
    hid: "smc",
    n: "이옥정",
    de: "심장혈관흉부외과",
    s: ["선천성심장질환", "중환자"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0384",
    hid: "smc",
    n: "임석경",
    de: "심장혈관흉부외과",
    s: ["심장로봇수술", "관상동맥"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0385",
    hid: "smc",
    n: "오시원",
    de: "심장혈관흉부외과",
    s: ["관상동맥수술", "대동맥수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0386",
    hid: "smc",
    n: "정지혁",
    de: "심장혈관흉부외과",
    s: ["인공심장및에크모", "심장외과중환자"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0387",
    hid: "smc",
    n: "전지훈",
    de: "심장혈관흉부외과",
    s: ["중환자의학", "중환자관리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0388",
    hid: "smc",
    n: "이재준",
    de: "심장혈관흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0389",
    hid: "smc",
    n: "최용수",
    de: "심장혈관흉부외과",
    s: ["폐암", "소아흉부질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0390",
    hid: "smc",
    n: "김홍관",
    de: "심장혈관흉부외과",
    s: ["폐암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0391",
    hid: "smc",
    n: "조종호",
    de: "심장혈관흉부외과",
    s: ["흉강경수술", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0392",
    hid: "smc",
    n: "박성용",
    de: "심장혈관흉부외과",
    s: ["식도암로봇수술", "폐암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0393",
    hid: "smc",
    n: "이정희",
    de: "심장혈관흉부외과",
    s: ["폐암", "폐질환수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0394",
    hid: "smc",
    n: "전영정",
    de: "심장혈관흉부외과",
    s: ["폐암", "폐질환수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0395",
    hid: "smc",
    n: "윤동욱",
    de: "심장혈관흉부외과",
    s: ["폐암", "폐이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0396",
    hid: "smc",
    n: "장복순",
    de: "심장혈관흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0397",
    hid: "smc",
    n: "박지연",
    de: "심장혈관흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0398",
    hid: "smc",
    n: "함돈일",
    de: "안과",
    s: ["망막질환", "당뇨망막병증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0399",
    hid: "smc",
    n: "우경인",
    de: "안과",
    s: ["안성형", "눈주변부종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0400",
    hid: "smc",
    n: "박철용",
    de: "안과",
    s: ["각막이식", "각막질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0401",
    hid: "smc",
    n: "김상진",
    de: "안과",
    s: ["망막질환", "황반질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0402",
    hid: "smc",
    n: "박경아",
    de: "안과",
    s: ["레베르유전시신경병증(극희귀질환 진단의사)", "시신경병증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0403",
    hid: "smc",
    n: "한종철",
    de: "안과",
    s: ["녹내장", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0404",
    hid: "smc",
    n: "임동희",
    de: "안과",
    s: ["각막이식", "각막질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0405",
    hid: "smc",
    n: "박도영",
    de: "안과",
    s: ["녹내장", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0406",
    hid: "smc",
    n: "김재령",
    de: "안과",
    s: ["사시", "성인사시"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0407",
    hid: "smc",
    n: "윤제문",
    de: "안과",
    s: ["망막질환", "망막 박리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0408",
    hid: "smc",
    n: "손영우",
    de: "안과",
    s: ["각막이식", "근시"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0409",
    hid: "smc",
    n: "김정훈",
    de: "안과",
    s: ["안성형", "안와"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0410",
    hid: "smc",
    n: "황성순",
    de: "안과",
    s: ["망막질환", "황반질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0411",
    hid: "smc",
    n: "김성태",
    de: "영상의학과",
    s: ["신경영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0412",
    hid: "smc",
    n: "김태성",
    de: "영상의학과",
    s: ["흉부방사선학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0413",
    hid: "smc",
    n: "김지혜",
    de: "영상의학과",
    s: ["소아영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0414",
    hid: "smc",
    n: "최동일",
    de: "영상의학과",
    s: ["복부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0415",
    hid: "smc",
    n: "박홍석",
    de: "영상의학과",
    s: ["인터벤션영상의학", "혈관기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0416",
    hid: "smc",
    n: "박광보",
    de: "영상의학과",
    s: ["인터벤션영상의학", "간암의중재적시술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0417",
    hid: "smc",
    n: "김성현",
    de: "영상의학과",
    s: ["복부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0418",
    hid: "smc",
    n: "박병관",
    de: "영상의학과",
    s: ["산부인과질환", "비뇨의학질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0419",
    hid: "smc",
    n: "전평",
    de: "영상의학과",
    s: ["신경영상의학", "뇌혈관중재적치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0420",
    hid: "smc",
    n: "정명진",
    de: "영상의학과",
    s: ["흉부영상의학", "컴퓨터단층촬영"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0421",
    hid: "smc",
    n: "김건하",
    de: "영상의학과",
    s: ["뇌혈관중재적치료", "신경영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0422",
    hid: "smc",
    n: "최상희",
    de: "영상의학과",
    s: ["근골격계영상진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0423",
    hid: "smc",
    n: "신성욱",
    de: "영상의학과",
    s: ["인터벤션영상의학", "간이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0424",
    hid: "smc",
    n: "고은영",
    de: "영상의학과",
    s: ["유방영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0425",
    hid: "smc",
    n: "김찬교",
    de: "영상의학과",
    s: ["비뇨의학질환", "산부인과질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0426",
    hid: "smc",
    n: "조성기",
    de: "영상의학과",
    s: ["인터벤션영상의학", "간이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0427",
    hid: "smc",
    n: "이민우",
    de: "영상의학과",
    s: ["복부영상의학", "소화기영상진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0428",
    hid: "smc",
    n: "정우경",
    de: "영상의학과",
    s: ["복부영상의학", "간이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0429",
    hid: "smc",
    n: "어홍",
    de: "영상의학과",
    s: ["응급영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0430",
    hid: "smc",
    n: "김영곤",
    de: "영상의학과",
    s: ["복부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0431",
    hid: "smc",
    n: "한부경",
    de: "영상의학과",
    s: ["유방영상의학", "유방암영상진단및조직검사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0432",
    hid: "smc",
    n: "한수연",
    de: "영상의학과",
    s: ["갑상선"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0433",
    hid: "smc",
    n: "고은숙",
    de: "영상의학과",
    s: ["유방영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0434",
    hid: "smc",
    n: "유재욱",
    de: "영상의학과",
    s: ["신경영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0435",
    hid: "smc",
    n: "신정희",
    de: "영상의학과",
    s: ["갑상선"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0436",
    hid: "smc",
    n: "김태정",
    de: "영상의학과",
    s: ["흉부영상의학", "폐암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0437",
    hid: "smc",
    n: "이호연",
    de: "영상의학과",
    s: ["흉부영상의학", "폐결절생검"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0438",
    hid: "smc",
    n: "윤정환",
    de: "영상의학과",
    s: ["응급영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0439",
    hid: "smc",
    n: "김윤경",
    de: "영상의학과",
    s: ["흉부·호흡기계영상진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0440",
    hid: "smc",
    n: "송경두",
    de: "영상의학과",
    s: ["소화기종양의영상유도하소작술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0441",
    hid: "smc",
    n: "강태욱",
    de: "영상의학과",
    s: ["복부영상의학", "복부종양의진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0442",
    hid: "smc",
    n: "김성목",
    de: "영상의학과",
    s: ["심장혈관영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0443",
    hid: "smc",
    n: "윤영철",
    de: "영상의학과",
    s: ["근골격계영상진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0444",
    hid: "smc",
    n: "유소영",
    de: "영상의학과",
    s: ["소아영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0445",
    hid: "smc",
    n: "전태연",
    de: "영상의학과",
    s: ["소아영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0446",
    hid: "smc",
    n: "최지수",
    de: "영상의학과",
    s: ["유방영상의학", "갑상선"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0447",
    hid: "smc",
    n: "이인선",
    de: "영상의학과",
    s: ["흉부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0448",
    hid: "smc",
    n: "김한솔",
    de: "영상의학과",
    s: ["복부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0449",
    hid: "smc",
    n: "정세민",
    de: "영상의학과",
    s: ["흉부·호흡기계영상진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0450",
    hid: "smc",
    n: "김민영",
    de: "영상의학과",
    s: ["응급영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0451",
    hid: "smc",
    n: "황혜선",
    de: "영상의학과",
    s: ["흉부·호흡기계영상진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0452",
    hid: "smc",
    n: "민지혜",
    de: "영상의학과",
    s: ["복부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0453",
    hid: "smc",
    n: "차동익",
    de: "영상의학과",
    s: ["복부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0454",
    hid: "smc",
    n: "황정아",
    de: "영상의학과",
    s: ["복부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0455",
    hid: "smc",
    n: "강경아",
    de: "영상의학과",
    s: ["비뇨의학질환", "산부인과질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0456",
    hid: "smc",
    n: "이지현",
    de: "영상의학과",
    s: ["근골격계영상진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0457",
    hid: "smc",
    n: "차윤기",
    de: "영상의학과",
    s: ["흉부·호흡기계영상진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0458",
    hid: "smc",
    n: "신재승",
    de: "영상의학과",
    s: ["복부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0459",
    hid: "smc",
    n: "김응엽",
    de: "영상의학과",
    s: ["신경영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0460",
    hid: "smc",
    n: "김명경",
    de: "영상의학과",
    s: ["유방영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0461",
    hid: "smc",
    n: "이상엽",
    de: "영상의학과",
    s: ["인터벤션영상의학", "혈관기형색전술및경화치료(동정맥기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0462",
    hid: "smc",
    n: "손범석",
    de: "영상의학과",
    s: ["신경영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0463",
    hid: "smc",
    n: "이정민",
    de: "영상의학과",
    s: ["유방영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0464",
    hid: "smc",
    n: "박지은",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0465",
    hid: "smc",
    n: "박성구",
    de: "영상의학과",
    s: ["흉부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0466",
    hid: "smc",
    n: "이계호",
    de: "영상의학과",
    s: ["흉부·호흡기계영상진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0467",
    hid: "smc",
    n: "김초희",
    de: "영상의학과",
    s: ["흉부·호흡기계영상진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0468",
    hid: "smc",
    n: "박형인",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0469",
    hid: "smc",
    n: "양우진",
    de: "영상의학과",
    s: ["인터벤션영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0470",
    hid: "smc",
    n: "구교원",
    de: "영상의학과",
    s: ["복부영상의학", "간이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0471",
    hid: "smc",
    n: "성민정",
    de: "영상의학과",
    s: ["신경영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0472",
    hid: "smc",
    n: "허진석",
    de: "간담췌외과",
    s: ["췌장담도암", "담낭암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0473",
    hid: "smc",
    n: "한인웅",
    de: "간담췌외과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0474",
    hid: "smc",
    n: "김홍범",
    de: "간담췌외과",
    s: ["로봇수술", "췌장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0475",
    hid: "smc",
    n: "신상현",
    de: "간담췌외과",
    s: ["췌장암", "췌장낭종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0476",
    hid: "smc",
    n: "김형석",
    de: "간담췌외과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0477",
    hid: "smc",
    n: "채호창",
    de: "간담췌외과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0478",
    hid: "smc",
    n: "김지수",
    de: "내분비외과",
    s: ["갑상선암", "부갑상선의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0479",
    hid: "smc",
    n: "최준호",
    de: "내분비외과",
    s: ["갑상선수술", "부갑상선의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0480",
    hid: "smc",
    n: "김정한",
    de: "내분비외과",
    s: ["갑상선암", "갑상선양성종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0481",
    hid: "smc",
    n: "이준협",
    de: "내분비외과",
    s: ["갑상선암", "갑상선수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0482",
    hid: "smc",
    n: "이우용",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0483",
    hid: "smc",
    n: "윤성현",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0484",
    hid: "smc",
    n: "김희철",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0485",
    hid: "smc",
    n: "조용범",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0486",
    hid: "smc",
    n: "허정욱",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0487",
    hid: "smc",
    n: "박윤아",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0488",
    hid: "smc",
    n: "신정경",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0489",
    hid: "smc",
    n: "임지하",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0490",
    hid: "smc",
    n: "서정민",
    de: "소아외과",
    s: ["선천성소화기기형", "소아복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0491",
    hid: "smc",
    n: "이상훈",
    de: "소아외과",
    s: ["소아복강경수술", "탈장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0492",
    hid: "smc",
    n: "박성주",
    de: "소아외과",
    s: ["탈장", "소아복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0493",
    hid: "smc",
    n: "손준혁",
    de: "소아외과",
    s: ["소아복강경수술", "선천성소화기기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0494",
    hid: "smc",
    n: "김지수",
    de: "외과",
    s: ["갑상선암", "부갑상선의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0495",
    hid: "smc",
    n: "남석진",
    de: "외과",
    s: ["유방암", "유방악성질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0496",
    hid: "smc",
    n: "허진석",
    de: "외과",
    s: ["췌장담도암", "담낭암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0497",
    hid: "smc",
    n: "이우용",
    de: "외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0498",
    hid: "smc",
    n: "윤성현",
    de: "외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0499",
    hid: "smc",
    n: "손태성",
    de: "외과",
    s: ["위암", "복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0500",
    hid: "smc",
    n: "김석원",
    de: "외과",
    s: ["유방암", "유방난치성질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0501",
    hid: "smc",
    n: "이정언",
    de: "외과",
    s: ["유방암", "유방암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0502",
    hid: "smc",
    n: "서정민",
    de: "외과",
    s: ["선천성소화기기형", "소아복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0503",
    hid: "smc",
    n: "김희철",
    de: "외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0504",
    hid: "smc",
    n: "최민규",
    de: "외과",
    s: ["위암", "복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0505",
    hid: "smc",
    n: "조용범",
    de: "외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0506",
    hid: "smc",
    n: "최준호",
    de: "외과",
    s: ["갑상선수술", "부갑상선의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0507",
    hid: "smc",
    n: "이준호",
    de: "외과",
    s: ["위암", "위암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0508",
    hid: "smc",
    n: "허정욱",
    de: "외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0509",
    hid: "smc",
    n: "박양진",
    de: "외과",
    s: ["대동맥중재시술", "말초혈관중재시술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0510",
    hid: "smc",
    n: "박재범",
    de: "외과",
    s: ["신장이식(콩팥이식)", "후복막의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0511",
    hid: "smc",
    n: "유종한",
    de: "외과",
    s: ["유방암", "유방암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0512",
    hid: "smc",
    n: "박치민",
    de: "외과",
    s: ["중환자의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0513",
    hid: "smc",
    n: "박윤아",
    de: "외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0514",
    hid: "smc",
    n: "김종만",
    de: "외과",
    s: ["간이식", "간암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0515",
    hid: "smc",
    n: "이상훈",
    de: "외과",
    s: ["소아복강경수술", "탈장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0516",
    hid: "smc",
    n: "채병주",
    de: "외과",
    s: ["유방암수술", "유방악성질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0517",
    hid: "smc",
    n: "한인웅",
    de: "외과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0518",
    hid: "smc",
    n: "김정한",
    de: "외과",
    s: ["갑상선암", "갑상선양성종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0519",
    hid: "smc",
    n: "이세경",
    de: "외과",
    s: ["유방암", "유방암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0520",
    hid: "smc",
    n: "안지영",
    de: "외과",
    s: ["위암", "위종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0521",
    hid: "smc",
    n: "유재민",
    de: "외과",
    s: ["유방암", "유방로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0522",
    hid: "smc",
    n: "김홍범",
    de: "외과",
    s: ["로봇수술", "췌장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0523",
    hid: "smc",
    n: "유진수",
    de: "외과",
    s: ["간이식", "간암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0524",
    hid: "smc",
    n: "양신석",
    de: "외과",
    s: ["복부대동맥류", "경동맥협착증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0525",
    hid: "smc",
    n: "신정경",
    de: "외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0526",
    hid: "smc",
    n: "임희정",
    de: "외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0527",
    hid: "smc",
    n: "이교원",
    de: "외과",
    s: ["신장이식(콩팥이식)", "후복막의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0528",
    hid: "smc",
    n: "신상현",
    de: "외과",
    s: ["췌장암", "췌장낭종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0529",
    hid: "smc",
    n: "임지하",
    de: "외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0530",
    hid: "smc",
    n: "박웅기",
    de: "외과",
    s: ["유방암", "유방암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0531",
    hid: "smc",
    n: "정지정",
    de: "외과",
    s: ["유방암", "유방암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0532",
    hid: "smc",
    n: "이준협",
    de: "외과",
    s: ["갑상선암", "갑상선수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0533",
    hid: "smc",
    n: "정신석",
    de: "외과",
    s: ["외과응급진료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0534",
    hid: "smc",
    n: "박준기",
    de: "외과",
    s: ["복부대동맥류", "경동맥협착증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0535",
    hid: "smc",
    n: "오성은",
    de: "외과",
    s: ["위암", "위장관기질종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0536",
    hid: "smc",
    n: "안상훈",
    de: "외과",
    s: ["위장관기질종양", "비만대사수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0537",
    hid: "smc",
    n: "이초은",
    de: "외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0538",
    hid: "smc",
    n: "정수연",
    de: "외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0539",
    hid: "smc",
    n: "조민경",
    de: "외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0540",
    hid: "smc",
    n: "최정원",
    de: "외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0541",
    hid: "smc",
    n: "오남기",
    de: "외과",
    s: ["간이식", "간암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0542",
    hid: "smc",
    n: "김형석",
    de: "외과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0543",
    hid: "smc",
    n: "채호창",
    de: "외과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0544",
    hid: "smc",
    n: "최규성",
    de: "외과",
    s: ["간이식", "간암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0545",
    hid: "smc",
    n: "박성주",
    de: "외과",
    s: ["탈장", "소아복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0546",
    hid: "smc",
    n: "유기상",
    de: "외과",
    s: ["외과응급진료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0547",
    hid: "smc",
    n: "오창규",
    de: "외과",
    s: ["외과응급진료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0548",
    hid: "smc",
    n: "류영주",
    de: "외과",
    s: ["간암", "후복막의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0549",
    hid: "smc",
    n: "이은진",
    de: "외과",
    s: ["간암", "후복막의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0550",
    hid: "smc",
    n: "최경진",
    de: "외과",
    s: ["외과응급진료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0551",
    hid: "smc",
    n: "홍지윤",
    de: "외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0552",
    hid: "smc",
    n: "정명재",
    de: "외과",
    s: ["외과응급진료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0553",
    hid: "smc",
    n: "민승기",
    de: "외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0554",
    hid: "smc",
    n: "손준혁",
    de: "외과",
    s: ["소아복강경수술", "선천성소화기기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0555",
    hid: "smc",
    n: "손태성",
    de: "위장관외과",
    s: ["위암", "복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0556",
    hid: "smc",
    n: "최민규",
    de: "위장관외과",
    s: ["위암", "복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0557",
    hid: "smc",
    n: "이준호",
    de: "위장관외과",
    s: ["위암", "위암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0558",
    hid: "smc",
    n: "안지영",
    de: "위장관외과",
    s: ["위암", "위종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0559",
    hid: "smc",
    n: "오성은",
    de: "위장관외과",
    s: ["위암", "위장관기질종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0560",
    hid: "smc",
    n: "안상훈",
    de: "위장관외과",
    s: ["위장관기질종양", "비만대사수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0561",
    hid: "smc",
    n: "민승기",
    de: "위장관외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0562",
    hid: "smc",
    n: "남석진",
    de: "유방외과",
    s: ["유방암", "유방악성질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0563",
    hid: "smc",
    n: "김석원",
    de: "유방외과",
    s: ["유방암", "유방난치성질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0564",
    hid: "smc",
    n: "이정언",
    de: "유방외과",
    s: ["유방암", "유방암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0565",
    hid: "smc",
    n: "유종한",
    de: "유방외과",
    s: ["유방암", "유방암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0566",
    hid: "smc",
    n: "채병주",
    de: "유방외과",
    s: ["유방암수술", "유방악성질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0567",
    hid: "smc",
    n: "이세경",
    de: "유방외과",
    s: ["유방암", "유방암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0568",
    hid: "smc",
    n: "유재민",
    de: "유방외과",
    s: ["유방암", "유방로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0569",
    hid: "smc",
    n: "박웅기",
    de: "유방외과",
    s: ["유방암", "유방암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0570",
    hid: "smc",
    n: "정지정",
    de: "유방외과",
    s: ["유방암", "유방암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0571",
    hid: "smc",
    n: "이초은",
    de: "유방외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0572",
    hid: "smc",
    n: "정수연",
    de: "유방외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0573",
    hid: "smc",
    n: "조민경",
    de: "유방외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0574",
    hid: "smc",
    n: "최정원",
    de: "유방외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0575",
    hid: "smc",
    n: "박재범",
    de: "이식외과",
    s: ["신장이식(콩팥이식)", "후복막의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0576",
    hid: "smc",
    n: "김종만",
    de: "이식외과",
    s: ["간이식", "간암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0577",
    hid: "smc",
    n: "유진수",
    de: "이식외과",
    s: ["간이식", "간암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0578",
    hid: "smc",
    n: "이교원",
    de: "이식외과",
    s: ["신장이식(콩팥이식)", "후복막의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0579",
    hid: "smc",
    n: "오남기",
    de: "이식외과",
    s: ["간이식", "간암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0580",
    hid: "smc",
    n: "최규성",
    de: "이식외과",
    s: ["간이식", "간암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0581",
    hid: "smc",
    n: "류영주",
    de: "이식외과",
    s: ["간암", "후복막의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0582",
    hid: "smc",
    n: "이은진",
    de: "이식외과",
    s: ["간암", "후복막의종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0583",
    hid: "smc",
    n: "박양진",
    de: "혈관외과",
    s: ["대동맥중재시술", "말초혈관중재시술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0584",
    hid: "smc",
    n: "양신석",
    de: "혈관외과",
    s: ["복부대동맥류", "경동맥협착증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0585",
    hid: "smc",
    n: "박준기",
    de: "혈관외과",
    s: ["복부대동맥류", "경동맥협착증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0586",
    hid: "smc",
    n: "송근정",
    de: "응급의학과",
    s: ["심폐소생술", "응급의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0587",
    hid: "smc",
    n: "최진호",
    de: "응급의학과",
    s: ["허혈성심질환", "협심증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0588",
    hid: "smc",
    n: "조익준",
    de: "응급의학과",
    s: ["중환자의학", "초음파"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0589",
    hid: "smc",
    n: "심민섭",
    de: "응급의학과",
    s: ["응급의학", "심장정지"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0590",
    hid: "smc",
    n: "신태건",
    de: "응급의학과",
    s: ["응급의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0591",
    hid: "smc",
    n: "차원철",
    de: "응급의학과",
    s: ["응급의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0592",
    hid: "smc",
    n: "황승연",
    de: "응급의학과",
    s: ["응급의학", "중환자의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0593",
    hid: "smc",
    n: "윤희",
    de: "응급의학과",
    s: ["응급의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0594",
    hid: "smc",
    n: "김태림",
    de: "응급의학과",
    s: ["응급의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0595",
    hid: "smc",
    n: "손명희",
    de: "응급의학과",
    s: ["소아응급의학", "디지털 헬스"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0596",
    hid: "smc",
    n: "이세욱",
    de: "응급의학과",
    s: ["응급의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0597",
    hid: "smc",
    n: "이건탁",
    de: "응급의학과",
    s: ["응급의학", "심장정지"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0598",
    hid: "smc",
    n: "박종은",
    de: "응급의학과",
    s: ["응급의학", "중환자의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0599",
    hid: "smc",
    n: "장한솔",
    de: "응급의학과",
    s: ["응급의학", "응급의료체계"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0600",
    hid: "smc",
    n: "허세진",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0601",
    hid: "smc",
    n: "김민하",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0602",
    hid: "smc",
    n: "맹승진",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0603",
    hid: "smc",
    n: "이현정",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0604",
    hid: "smc",
    n: "박미란",
    de: "응급의학과",
    s: ["소아응급의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0605",
    hid: "smc",
    n: "유혜수",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0606",
    hid: "smc",
    n: "임하나",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0607",
    hid: "smc",
    n: "김민주",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0608",
    hid: "smc",
    n: "김다슬",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0609",
    hid: "smc",
    n: "손영익",
    de: "이비인후과",
    s: ["후두암", "갑상선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0610",
    hid: "smc",
    n: "조양선",
    de: "이비인후과",
    s: ["중이염", "인공와우이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0611",
    hid: "smc",
    n: "정원호",
    de: "이비인후과",
    s: ["어지러움", "중이염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0612",
    hid: "smc",
    n: "정한신",
    de: "이비인후과",
    s: ["타액선암", "구강암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0613",
    hid: "smc",
    n: "김효열",
    de: "이비인후과",
    s: ["수면무호흡증", "코기능성형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0614",
    hid: "smc",
    n: "정만기",
    de: "이비인후과",
    s: ["구강암", "구인두암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0615",
    hid: "smc",
    n: "정용기",
    de: "이비인후과",
    s: ["축농증내시경수술", "비부비동종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0616",
    hid: "smc",
    n: "문일준",
    de: "이비인후과",
    s: ["인공와우이식", "돌발성난청"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0617",
    hid: "smc",
    n: "홍상덕",
    de: "이비인후과",
    s: ["비부비동종양", "두개저내시경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0618",
    hid: "smc",
    n: "최나연",
    de: "이비인후과",
    s: ["두경부암수술", "두경부재건"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0619",
    hid: "smc",
    n: "조영상",
    de: "이비인후과",
    s: ["얼굴신경마비(안면마비)", "난청(청력소실)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0620",
    hid: "smc",
    n: "류광희",
    de: "이비인후과",
    s: ["비부비동암", "비부비동종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0621",
    hid: "smc",
    n: "김영학",
    de: "이비인후과",
    s: ["두경부암수술", "두경부종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0622",
    hid: "smc",
    n: "허유진",
    de: "이비인후과",
    s: ["난청(청력소실)", "이명(귀울림)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0623",
    hid: "smc",
    n: "성덕현",
    de: "재활의학과",
    s: ["경추", "흉추"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0624",
    hid: "smc",
    n: "황지혜",
    de: "재활의학과",
    s: ["족부질환", "부종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0625",
    hid: "smc",
    n: "권정이",
    de: "재활의학과",
    s: ["소아", "소아재활"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0626",
    hid: "smc",
    n: "김대현",
    de: "재활의학과",
    s: ["뇌경색", "뇌졸중"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0627",
    hid: "smc",
    n: "장원혁",
    de: "재활의학과",
    s: ["뇌손상", "뇌졸중"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0628",
    hid: "smc",
    n: "도종걸",
    de: "재활의학과",
    s: ["근골격계질환", "견관절질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0629",
    hid: "smc",
    n: "임유진",
    de: "재활의학과",
    s: ["척추통", "견관절질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0630",
    hid: "smc",
    n: "정유숙",
    de: "정신건강의학과",
    s: ["소아청소년정신질환", "주의력결핍과잉운동장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0631",
    hid: "smc",
    n: "홍진표",
    de: "정신건강의학과",
    s: ["공황장애", "우울증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0632",
    hid: "smc",
    n: "윤세창",
    de: "정신건강의학과",
    s: ["정신신체장애", "암환자정신건강"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0633",
    hid: "smc",
    n: "전홍진",
    de: "정신건강의학과",
    s: ["우울증", "기분장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0634",
    hid: "smc",
    n: "김석주",
    de: "정신건강의학과",
    s: ["불면증", "스트레스/트라우마"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0635",
    hid: "smc",
    n: "최홍",
    de: "정신건강의학과",
    s: ["스트레스평가및관리(건강의학센터)", "임직원정신건강상담"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0636",
    hid: "smc",
    n: "최정석",
    de: "정신건강의학과",
    s: ["정신분열병(조현병)", "양극성장애(조울증)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0637",
    hid: "smc",
    n: "백지현",
    de: "정신건강의학과",
    s: ["양극성장애(조울증)", "정신분열병(조현병)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0638",
    hid: "smc",
    n: "안지현",
    de: "정신건강의학과",
    s: ["18"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0639",
    hid: "smc",
    n: "강나옥",
    de: "정신건강의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0640",
    hid: "smc",
    n: "장유진",
    de: "정신건강의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0641",
    hid: "smc",
    n: "박민종",
    de: "정형외과",
    s: ["손목관절", "팔꿈치관절의질환이나외상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0642",
    hid: "smc",
    n: "문영완",
    de: "정형외과",
    s: ["무릎인공관절치환술", "무릎퇴행성관절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0643",
    hid: "smc",
    n: "왕준호",
    de: "정형외과",
    s: ["전방십자인대파열", "스포츠손상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0644",
    hid: "smc",
    n: "성기선",
    de: "정형외과",
    s: ["발목및발의변형", "힘줄의파열"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0645",
    hid: "smc",
    n: "유재철",
    de: "정형외과",
    s: ["견갑골주변의스포츠손상", "어깨질병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0646",
    hid: "smc",
    n: "임승재",
    de: "정형외과",
    s: ["고관절질환", "대퇴골두무혈성괴사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0647",
    hid: "smc",
    n: "서성욱",
    de: "정형외과",
    s: ["골낭종", "병적골절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0648",
    hid: "smc",
    n: "이대희",
    de: "정형외과",
    s: ["전방십자인대파열", "무릎인공관절치환술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0649",
    hid: "smc",
    n: "박세준",
    de: "정형외과",
    s: ["척추측만증(척추옆굽음증)", "척추후만증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0650",
    hid: "smc",
    n: "박진성",
    de: "정형외과",
    s: ["최소침습척추수술", "척추내시경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0651",
    hid: "smc",
    n: "심재우",
    de: "정형외과",
    s: ["수부/손목/팔꿈치질환", "상지외상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0652",
    hid: "smc",
    n: "고경래",
    de: "정형외과",
    s: ["소아정형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0653",
    hid: "smc",
    n: "박찬우",
    de: "정형외과",
    s: ["고관절주위골절", "하지외상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0654",
    hid: "smc",
    n: "김수철",
    de: "정형외과",
    s: ["어깨탈구및골절", "어깨질병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0655",
    hid: "smc",
    n: "강동호",
    de: "정형외과",
    s: ["척추종양", "척추후만증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0656",
    hid: "smc",
    n: "이영근",
    de: "정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0657",
    hid: "smc",
    n: "서지영",
    de: "중환자의학과",
    s: ["중환자의학", "중환자관리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0658",
    hid: "smc",
    n: "박치민",
    de: "중환자의학과",
    s: ["중환자의학", "중증외상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0659",
    hid: "smc",
    n: "양정훈",
    de: "중환자의학과",
    s: ["중환자의학", "심인성쇼크"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0660",
    hid: "smc",
    n: "정치량",
    de: "중환자의학과",
    s: ["중환자의학", "중환자조기이동(재활)치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0661",
    hid: "smc",
    n: "조중범",
    de: "중환자의학과",
    s: ["중환자의학", "체외막형산소화요법"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0662",
    hid: "smc",
    n: "유정암",
    de: "중환자의학과",
    s: ["중환자의학", "신경중환자치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0663",
    hid: "smc",
    n: "길은미",
    de: "중환자의학과",
    s: ["중환자의학", "간이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0664",
    hid: "smc",
    n: "나수진",
    de: "중환자의학과",
    s: ["중환자의학", "중환자관리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0665",
    hid: "smc",
    n: "고령은",
    de: "중환자의학과",
    s: ["중환자의학", "급성호흡부전"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0666",
    hid: "smc",
    n: "최재영",
    de: "중환자의학과",
    s: ["중환자의학", "소아기관지내시경"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0667",
    hid: "smc",
    n: "차지현",
    de: "중환자의학과",
    s: ["중환자의학", "심인성쇼크"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0668",
    hid: "smc",
    n: "홍윤희",
    de: "중환자의학과",
    s: ["중환자의학", "신경중환자치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0669",
    hid: "smc",
    n: "박효준",
    de: "중환자의학과",
    s: ["중환자의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0670",
    hid: "smc",
    n: "강은숙",
    de: "진단검사의학과",
    s: ["진단면역", "이식면역"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0671",
    hid: "smc",
    n: "이수연",
    de: "진단검사의학과",
    s: ["약물유전학", "특수화학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0672",
    hid: "smc",
    n: "조덕",
    de: "진단검사의학과",
    s: ["수혈의학", "세포치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0673",
    hid: "smc",
    n: "김희진",
    de: "진단검사의학과",
    s: ["진단혈액", "혈액유전학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0674",
    hid: "smc",
    n: "박형두",
    de: "진단검사의학과",
    s: ["임상화학", "생화학유전학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0675",
    hid: "smc",
    n: "장자현",
    de: "진단검사의학과",
    s: ["진단분자유전학", "신경유전학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0676",
    hid: "smc",
    n: "허희재",
    de: "진단검사의학과",
    s: ["임상미생물", "분자미생물학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0677",
    hid: "smc",
    n: "장미애",
    de: "진단검사의학과",
    s: ["분자유전"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0678",
    hid: "smc",
    n: "김현영",
    de: "진단검사의학과",
    s: ["진단혈액", "혈액유전학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0679",
    hid: "smc",
    n: "김태열",
    de: "진단검사의학과",
    s: ["임상미생물", "분자미생물학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0680",
    hid: "smc",
    n: "김영곤",
    de: "진단검사의학과",
    s: ["분자유전", "암유전학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0681",
    hid: "smc",
    n: "윤혜령",
    de: "진단검사의학과",
    s: ["세포유전", "진단혈액"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0682",
    hid: "smc",
    n: "양정석",
    de: "진단검사의학과",
    s: ["진단면역", "이식면역"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0683",
    hid: "smc",
    n: "안아리",
    de: "진단검사의학과",
    s: ["진단혈액", "혈액유전학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0684",
    hid: "smc",
    n: "남민정",
    de: "진단검사의학과",
    s: ["세포치료", "수혈의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0685",
    hid: "smc",
    n: "김재력",
    de: "진단검사의학과",
    s: ["진단유전학", "분자유전"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0686",
    hid: "smc",
    n: "류미라",
    de: "진단검사의학과",
    s: ["임상미생물", "분자미생물학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0687",
    hid: "smc",
    n: "우수현",
    de: "진단검사의학과",
    s: ["진단혈액", "혈액유전학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0688",
    hid: "smc",
    n: "이건혁",
    de: "진단검사의학과",
    s: ["진단유전학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0689",
    hid: "smc",
    n: "박동성",
    de: "치과",
    s: ["신경치료", "미세현미경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0690",
    hid: "smc",
    n: "김정혜",
    de: "치과",
    s: ["치주조직재생", "심미치주"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0691",
    hid: "smc",
    n: "유현미",
    de: "치과",
    s: ["치아우식증", "예방및수복치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0692",
    hid: "smc",
    n: "계승범",
    de: "치과",
    s: ["만성치주염", "임플란트"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0693",
    hid: "smc",
    n: "김석규",
    de: "치과",
    s: ["임플란트", "심미보철"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0694",
    hid: "smc",
    n: "이동환",
    de: "치과",
    s: ["임플란트", "틀니(의치)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0695",
    hid: "smc",
    n: "양승민",
    de: "치과",
    s: ["만성치주염", "치아치은성형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0696",
    hid: "smc",
    n: "양미영",
    de: "치과",
    s: ["신경치료", "치아우식증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0697",
    hid: "smc",
    n: "팽준영",
    de: "치과",
    s: ["악안면기형", "악안면종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0698",
    hid: "smc",
    n: "최혜원",
    de: "치과",
    s: ["소아청소년턱/치아교정치료", "성인치열교정"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0699",
    hid: "smc",
    n: "이주리",
    de: "치과",
    s: ["임플란트", "틀니(의치)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0700",
    hid: "smc",
    n: "안재명",
    de: "치과",
    s: ["악안면기형", "양악수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0701",
    hid: "smc",
    n: "권도현",
    de: "치과",
    s: ["구강암", "악안면재건"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0702",
    hid: "smc",
    n: "이주흥",
    de: "피부과",
    s: ["건선"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0703",
    hid: "smc",
    n: "이동윤",
    de: "피부과",
    s: ["피부암(흑색종포함)", "손발톱질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0704",
    hid: "smc",
    n: "이종희",
    de: "피부과",
    s: ["암수술흉터 예방과 치료", "중증 성인아토피"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0705",
    hid: "smc",
    n: "박지혜",
    de: "피부과",
    s: ["피부외과(수술)", "악성종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0706",
    hid: "smc",
    n: "오세진",
    de: "피부과",
    s: ["건선", "레이저치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0707",
    hid: "smc",
    n: "최준영",
    de: "핵의학과",
    s: ["종양핵의학", "심장핵의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0708",
    hid: "smc",
    n: "조영석",
    de: "핵의학과",
    s: ["종양핵의학", "일반핵의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0709",
    hid: "smc",
    n: "문승환",
    de: "핵의학과",
    s: ["종양핵의학", "신경핵의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0710",
    hid: "smc",
    n: "현승협",
    de: "핵의학과",
    s: ["종양핵의학", "일반핵의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0711",
    hid: "smc",
    n: "이현종",
    de: "핵의학과",
    s: ["종양핵의학", "심장핵의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "smc-0712",
    hid: "smc",
    n: "위원석",
    de: "핵의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
];
